



























































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  modalBibliographyDetailStore,
  modalBibliographySearchResultAuthorityStore,
  modalBibliographySearchStore,
  modalErrorStore,
  modalJobListStore
} from '@/utils/store-accessor'
import { AlertCodeILC00005, AuthoritySearchType } from '@/types'
import { Alert, AlertMessage, ErrorMessage, jobApi } from '@/api'
import { AlertFactory } from '@/factory'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { BibliographySearchResultsAuthorityTable } from '@/components/organisms/BibliographySearchResultsAuthorityTable'
import { FirstTransitionToBibliographyDetail } from '@/store/BibliographyDetailStore'

@Component({
  components: {
    ModalFooter,
    BibliographySearchResultsAuthorityTable
  }
})
export default class ModalBibliographySearchResultAuthority extends ModalComponentBaseVue {
  tableBodyHeight: number = 0

  selectedAuthorityNos: string[] = []

  isAllSelect: boolean = false

  scrollTop: number = 0

  activeRowIndex: number = 0

  get isOpen() {
    return modalBibliographySearchResultAuthorityStore.isOpen
  }

  get authoritySearchType() {
    return modalBibliographySearchStore.authoritySearchType
  }

  get displayLabel() {
    switch (this.authoritySearchType) {
      case AuthoritySearchType.Author:
      case AuthoritySearchType.ContentAuthor:
        return '責任表示'
      case AuthoritySearchType.Subject:
        return '件名'
      case AuthoritySearchType.CompleteWorks:
        return '全集'
      case AuthoritySearchType.Series:
        return 'シリーズ'
      case AuthoritySearchType.Publisher:
        return '出版者'
    }
  }

  get displayTableIsSimple() {
    switch (this.authoritySearchType) {
      case AuthoritySearchType.Author:
      case AuthoritySearchType.ContentAuthor:
        return false
    }

    return true
  }

  get searchKeyWord() {
    const item = modalBibliographySearchStore.inputAuthoritySearchItem

    switch (this.authoritySearchType) {
      case AuthoritySearchType.Author:
        return item.author.input
      case AuthoritySearchType.ContentAuthor:
        return item.contentAuthor.input
      case AuthoritySearchType.Subject:
        return item.subject.input
      case AuthoritySearchType.CompleteWorks:
        return item.series.input
      case AuthoritySearchType.Series:
        return item.completeWorks.input
      case AuthoritySearchType.Publisher:
        return item.publisher.input
    }
  }

  get displayItems() {
    return modalBibliographySearchStore.authorityItems
  }

  get existsDisplayItems(): boolean {
    return this.displayItems.length > 0
  }

  @Watch('displayItems')
  initializeChecked(): void {
    this.isAllSelect = false
    this.selectedAuthorityNos = []
  }

  @Watch('isOpen')
  initialize() {
    if (this.isOpen) {
      window.addEventListener('resize', this.calculateTableHeight)
      this.$nextTick(() => {
        this.calculateTableHeight()
        setTimeout(() => {
          this.scrollTop = modalBibliographySearchStore.authorityScrollTopValue
          this.activeRowIndex =
            modalBibliographySearchStore.authorityActiveRowIndex
          this.setScroll()
        })
      })
      return
    }

    modalBibliographySearchStore.setAuthorityScrollTopValue(this.scrollTop)
    modalBibliographySearchStore.setAuthorityActiveRowIndex(this.activeRowIndex)
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onChangeAllSelect(value: boolean) {
    this.isAllSelect = value

    if (this.isAllSelect) {
      this.selectedAuthorityNos = this.displayItems.map(
        item => item.authorityNo
      )
    } else {
      this.selectedAuthorityNos = []
    }
  }

  onClickBack() {
    modalBibliographySearchResultAuthorityStore.back()
  }

  onClickPrint(): void {
    const element = document.getElementById(
      'modal-bibliography-search-result-authority'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onClickSelect() {
    if (this.selectedAuthorityNos.length === 0) {
      const alert: Alert = AlertFactory.create(
        AlertCodeILC00005,
        '一覧表示',
        '行'
      )
      alertStore.setItem(alert)
      this.$modalAlert.open()
      return
    }

    if (this.authoritySearchType === AuthoritySearchType.ContentAuthor) {
      this.authorityIdContentSearch()
    } else {
      this.authorityIdSearch()
    }
  }

  async authorityIdSearch() {
    this.$eventBus.emit(PAGE_LOADING_START)

    const ids = [...this.selectedAuthorityNos]

    try {
      modalBibliographySearchStore.resetPage()

      switch (this.authoritySearchType) {
        case AuthoritySearchType.Author:
          modalBibliographySearchStore.setAuthorIds(ids)
          break
        case AuthoritySearchType.ContentAuthor:
          modalBibliographySearchStore.setContentAuthorIds(ids)
          break
        case AuthoritySearchType.Subject:
          modalBibliographySearchStore.setSubjectIds(ids)
          break
        case AuthoritySearchType.CompleteWorks:
          modalBibliographySearchStore.setCompleteWorksIds(ids)
          break
        case AuthoritySearchType.Series:
          modalBibliographySearchStore.setSeriesIds(ids)
          break
        case AuthoritySearchType.Publisher:
          modalBibliographySearchStore.setPublisherIds(ids)
          break
      }

      await modalBibliographySearchStore.authorityIdSearch()

      modalBibliographyDetailStore.setFirstTransitionSource(
        FirstTransitionToBibliographyDetail.SearchResult
      )

      this.goSearchResultModal()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async authorityIdContentSearch() {
    this.$eventBus.emit(PAGE_LOADING_START)

    const nos = [...this.selectedAuthorityNos]

    try {
      modalBibliographySearchStore.resetPage()
      modalBibliographySearchStore.setContentAuthorIds(nos)

      await modalBibliographySearchStore.authorityIdContentSearch()
      this.goSearchResultModal()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  goSearchResultModal() {
    modalBibliographySearchResultAuthorityStore.search()
  }

  close() {
    modalBibliographySearchResultAuthorityStore.close()
  }

  setScrollTop(value: number): void {
    this.scrollTop = value
  }

  setScroll(): void {
    setTimeout(() => {
      const tableScroller: HTMLCollection | null = document.getElementsByClassName(
        'search-result-authority-scroller'
      ) as HTMLCollectionOf<HTMLElement>

      tableScroller[0].scrollTo(0, this.scrollTop)
    })
  }

  setActiveRow(index: number): void {
    this.activeRowIndex = index
  }

  async createBibliographySearchAuthorityList(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const jobId = await jobApi.createBibliographySearchAuthorityList({
        formatType: '1', // TODO 工事中、暫定表示
        authorities: this.displayItems.map(item => {
          return {
            authorityNo: item.authorityNo,
            display: item.display,
            reference: item.reference,
            specialty: item.specialty,
            yearOfBirth: item.yearOfBirth,
            work: item.work,
            bibliographyCount: item.bibliographyCount
          }
        })
      })

      await modalJobListStore.newJobId(jobId)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
